<!-- 协议 -->
<template>
  <div class="wrap">
    <div v-html="config[configKey]"></div>
  </div>
</template>

<script>
import { ExpediteService } from "@/common/service";

export default {
  components: {},
  data() {
    return {
      configTitleMap: {
        agreement: "用户协议",
        about_us: "关于我们",
        privacy: "隐私政策",
        user_equity: "会员权益",
        customer_service: "客服设置",
      },
      config: {
        agreement: "", // 用户协议
        about_us: "", // 关于我们
        privacy: "", // 隐私政策
        user_equity: "", // 会员权益
        customer_service: "", // 客服设置
      },
      configKey: "agreement",
    };
  },
  mounted() {
    const option = this.$route.query;
    this.configKey = option.configKey || this.configKey;
    this.getSysConfig();
    window.scrollTo(0, 0);
  },
  methods: {
    getSysConfig() {
      ExpediteService.getSysConfig().then(({ data }) => (this.config = data));
    },
  },
};
</script>

<style lang="scss" scoped>
.wrap {
  width: 70%;
  min-height: calc(100vh - 120px);
  margin: 0 auto;
  min-width: 1000px;
  background: white;
  font-size: 16px;
  div {
    margin-top: 15px;
    padding: 10px 20px;
  }
}
</style>
